// @ts-check
import React, { Component } from 'react';
import SpinnerButton from './SpinnerButton';

/** @typedef {{
  onClick: (...args) => any
} & React.ButtonHTMLAttributes} PromiseButtonPropsType */

/** @typedef {{
  submitting: boolean
}} PromiseButtonStateType */

/** @augments { Component<PromiseButtonPropsType, PromiseButtonStateType> } */
class PromiseButton extends Component {
  constructor(props) {
    super(props);
    this.state = { submitting: false };
    this.onClick = this.onClick.bind(this);
  }

  onClick(...args) {
    this.submitting();
    return Promise.resolve(this.props.onClick(...args)).then(
      response => {
        this.notSubmitting();
        return response;
      },
      error => {
        this.notSubmitting();
        throw error;
      }
    );
  }

  submitting() {
    this.setState({ submitting: true });
  }

  notSubmitting() {
    this.setState({ submitting: false });
  }

  render() {
    return <SpinnerButton {...this.props} loading={this.state.submitting} onClick={this.onClick} />;
  }
}

export default PromiseButton;
